
import ViewBox from 'vux/src/components/view-box/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getWebSiteName ,getAdmissionsProfile,getWebSiteAddress} from '@/api/main'
export default {
name: 'Layout',
components: {
ViewBox,
Tabbar,
TabbarItem,
Group,
Cell
},
data () {
return {
AdmissionsProfile:'',
WebSiteAddress:''
}
},
created(){
getWebSiteName().then(response => {
document.title = response.data + '报名平台'
})
getAdmissionsProfile().then(response => {
this.AdmissionsProfile= response.data
})
getWebSiteAddress().then(response => {
this.WebSiteAddress = response.data
})
},
methods: {
handleShare() {
this.$router.push({ path: '/login' })
},
chatQQ(){
this.$router.push({ path: '/contactOnline' })
},
admissionInfo(){

window.location.href = process.env.BASE_API + '/notice/'+'入学须知.png'
}
}
}



// WEBPACK FOOTER //
// ./src/views/layout/Layout.vue